import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export type DeleteAiAgentRequest = {
	id: number
};

export const deleteAiAgent = createDeleteEndpoint< DeleteAiAgentRequest >(({ id }) =>
	`/api/mcp/auth/connections/${id}`);
